import { render, staticRenderFns } from "./TextBanner.vue?vue&type=template&id=0f75bcd6&scoped=true"
import script from "./TextBanner.vue?vue&type=script&lang=js"
export * from "./TextBanner.vue?vue&type=script&lang=js"
import style0 from "./TextBanner.vue?vue&type=style&index=0&id=0f75bcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75bcd6",
  null
  
)

export default component.exports